module.exports = __webpack_public_path__ + "static/media/10_tn.c4818e96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/10_tn.jpg
// module id = 148
// module chunks = 0